(ns teamoesterreich.admin-mode.crowdtasker.event-overview
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.event :as d-events]
            [teamoesterreich.admin-mode.data.training :as d-trainings]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.crowdtasker.event-detail-form :as event-detail-form]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.message :as message-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.admin-mode.crowdtasker.event-region :as event-region]
            [teamoesterreich.admin-mode.crowdtasker.task.event-task-list :as task-list]
            [teamoesterreich.admin-mode.crowdtasker.task-result.event-task-result-list :as task-result-list]

            [teamoesterreich.admin-mode.crowdtasker.event-user-table :as event-user-table]
            [teamoesterreich.admin-mode.crowdtasker.event-response-table :as event-response-table]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.info :refer [info]]
            ))

(defn get-it []
  (let [!st (r/atom {})]
    (fn []
      (let [!event (r/cursor v-state/app-state [:selected-event])
            !actual-user (r/cursor store/app-state [:actual-user])
            !tab (r/cursor v-state/app-state [:crowdtasker-tab])
            !event-detail-loaded? (r/cursor v-state/app-state [:event-detail-loaded])
            !task-list-state (r/cursor v-state/app-state [:event :crowdtaskerTask-list-state :loaded])
            !show-delete? (r/cursor !st [:event-delete])
            !send-alarm? (r/cursor !st [:send-alarm?])
            !show-start-warn? (r/cursor !st [:show-start-warn])
            !show-end-warn? (r/cursor !st [:show-end-warn])
            !show-end-not-possible? (r/cursor !st [:show-end-not-possible])
            reload-fn #(reset! !event-detail-loaded? false)
            !publish-popup (r/cursor !st [:publish-popup])
            event-status (or (:crowdtaskerEvent-status @!event) "created")
            event-step (case event-status
                         "created" 0
                         "waitAccept" 1
                         "running" 2
                         "finished" 3
                         "closed" 4
                         0)
            cnt-memberStatus-fn (fn [status] (count (filter (fn [e] (and (= "undefined" (or (:crowdtaskerEventMember-missionState e) "undefined"))
                                                                         (= status (or (:crowdtaskerEventMember-responseState e) "undefined")))) (:crowdtaskerEvent-member @!event))))
            cnt-responseStatus-fn (fn [status] (count (:crowdtaskerEvent-response @!event)))
            ]

        ;(log/debug "Actual event  " @!event-detail-loaded? @!event)
        (when (nil? (:crowdtaskerEvent-uuid @!event))
          (a/set-page :event-list))

        [mui/grid
         {:container false :item true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:marginTop "5px"}
          }

         [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                      :onClick   #(swap! v-state/app-state assoc
                                         :edit-crowdtaskerQuestion nil
                                         :site :event-list)
                      }
          "Zurück"]

         [mui/button {:startIcon (r/as-element [refresh])
                      :onClick   #(reset! !event-detail-loaded? false)}
          "Neu laden ...."
          ]]


        (if-not @!event-detail-loaded?
          (do
            (if (:crowdtaskerEvent-uuid @!event)
              (d-events/<event-load (:crowdtaskerEvent-uuid @!event)
                                    (fn [response]
                                      (reset! !event response)
                                      (reset! !event-detail-loaded? true)
                                      ))
              (a/set-page :crowdtasker-list))
            [mui/grid
             {:container false :item true
              :md        12                                 ;medium: 960px
              :xs        12                                 ;extra-small: 0px
              :style     {:marginTop "5px"}
              }
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )

          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "5px"}
            }
           [mui/card
            [mui/grid {:container true :direction "row" :justify "flex-start" :alignItems "flex-start"}
             [mui/grid {:container false :item true :xs 9}
              [mui/card-header {:title   (str "Einsatz " (:crowdtaskerEvent-toeEventId @!event) " ) " (:crowdtaskerEvent-name @!event))
                                :style   {:padding "0 0  5px 0"}
                                :onClick (fn []
                                           (reset! !task-list-state false)
                                           (reset! !event-detail-loaded? false))
                                }]
              ]
             [mui/grid {:container false :item true :xs 3}
              [ws-event-sync-component/ws-event-reload !event-detail-loaded? :crowdtasker-event (:crowdtaskerEvent-uuid @!event)]
              ]
             ]

            [are-you-sure-modal/are-you-sure-modal !publish-popup
             "Bist du sicher, dass du diesen Einsatz veröffentlichen möchtest? Alle Teilnehmer werden ihn sehen können!" "Ja veröffentlichen"
             (fn [_] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-published true} reload-fn))]

            [mui/card-content {}
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    3
               :style      {:margin "0"}
               }

              [mui/grid
               {:container false :item true
                :md        9
                :xs        12
                :style     {:padding "5px"}
                }
               [mui/stepper {:active-step event-step}
                [mui/step {
                           :key "Step1"
                           }
                 [mui/step-label "Erstellen"]]

                [mui/step {
                           :key "Step2"
                           }
                 [mui/step-label "Wartet auf Freischalten"]]

                [mui/step {
                           :key "Step3"
                           }
                 [mui/step-label "Läuft gerade"]]

                [mui/step {
                           :key "Step4"
                           }
                 [mui/step-label "Abgeschlossen"]]
                ]]
              [mui/grid
               {:container false :item true
                :md        3
                :xs        12
                :style     {:padding "5px"}
                }
               (when (> event-step 1)
                 [mui/form-group
                  [mui/form-control-label
                   {:style     {:paddingLeft "126px"}
                    :label     "Einsatz veröffentlichen"
                    :fullWidth true
                    :control   (r/as-element
                                 [mui/switch {:checked  (or (:crowdtaskerEvent-published @!event) false)
                                              :onChange (fn [_ v]
                                                          (log/debug "Set Published " v)
                                                          (if v (reset! !publish-popup true)
                                                                (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-published false} reload-fn)))
                                              }])}
                   ]])]
              ]]

            [mui/card-content {}
             [are-you-sure-modal/are-you-sure-modal !show-delete? "Nur für Superuser! Einsatz wirklich löschen ?" "löschen"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event)
                                           {:crowdtaskerEvent-active false}
                                           (fn [data] (swap! v-state/app-state assoc
                                                             :selected-event nil
                                                             :event-detail-loaded false
                                                             :event nil
                                                             :site :event-list
                                                             ))))]

             [are-you-sure-modal/are-you-sure-modal !show-start-warn? "Nur für Superuser! Es ist noch nicht Einsatzbeginn! Willst du ihn trotzdem starten ?" "Trotzdem starten"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))]

             [are-you-sure-modal/are-you-sure-modal !show-end-warn? "Willst du diesen Einsatz beenden ?" "beenden"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event)
                                           {:crowdtaskerEvent-status "finished"
                                            :crowdtaskerEvent-timeTo (or (:crowdtaskerEvent-timeTo @!event)
                                                                         (let [date (js/Date.)]
                                                                           (goog.string.format "%04d%02d%02dT%02d%02d%02d.000Z" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date) (.getSeconds date)) ;20180701T100000.000Z
                                                                           ))
                                            } (fn [data] (reset! !event-detail-loaded? false))))]

             [message-modal/modal !show-end-not-possible? (r/as-element [:p [warning] [:br] "Dieser Einsatz ist nicht abschließbar! " [:br] "Prüfe ob alle Teilnehmer auf `Reserve` oder `Im Einsatz` sind"])]


             [are-you-sure-modal/are-you-sure-modal !send-alarm? "Einsatz Push senden? (Nur Personen im Geofence werden informiert.)" "senden"
              (fn [] (d-events/>event-send-alarm (:crowdtaskerEvent-uuid @!event)))]

             (when (> event-step 1)
               [mui/button {:variant   "outlined" :color "secondary"
                            :disabled  (not (and
                                              (> (count (str (:crowdtaskerEvent-timeFrom @!event))) 0)
                                              (> (count (str (:crowdtaskerEvent-name @!event))) 0)
                                              ))
                            :startIcon (r/as-element [check])
                            :onClick   #(reset! !send-alarm? true)
                            :style     {:marginRight "10px"}}
                "Push senden"])

             (when (= event-status "created")
               [mui/button {:variant   "outlined" :color "secondary"
                            :disabled  (not (and
                                              (> (count (str (:crowdtaskerEvent-timeFrom @!event))) 0)
                                              (> (count (str (:crowdtaskerEvent-name @!event))) 0)
                                              ))
                            :startIcon (r/as-element [check])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "waitAccept"} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten beantragen"])


             (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CROWDTASKER_ACTIVATE))
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created"} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Ablehnen"])

             (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CROWDTASKER_ACTIVATE))
               [mui/button {:variant   "outlined" :color "secondary"
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running" :crowdtaskerEvent-published true} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten"])

             (when (and (= event-status "waitAccept") (not (d-rights/allow-admin-for d-rights/CROWDTASKER_ACTIVATE)))
               [mui/chip {:label "Wartet auf die Freigabe!" :color "#e10032" :icon (r/as-element [info])}])


             (when (= event-status "running")
               [mui/button {:variant  "outlined"

                            :disabled (> (cnt-responseStatus-fn "accepted") 0)
                            :onClick  (fn [] (if (and (= event-status "running"))
                                               (reset! !show-end-not-possible? true)
                                               (reset! !show-end-warn? true)
                                               ))
                            :color    "secondary"
                            :style    {:marginRight "10px"}}
                "Einsatz abschließen"])

             [:div {:style {:display "inline-block" :width "200px"}}]

             (when (= event-status "created")
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [delete-outline])
                            :onClick   #(reset! !show-delete? true)
                            :style     {:marginRight "10px"}}
                "Löschen"])

             (when (= event-status "running")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created" :crowdtaskerEvent-published false} (fn [data] (reset! !event-detail-loaded? false))))
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "Freischaltung zurücknehmen"])


             (when (= event-status "finished")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "beenden zurücknehmen"])


             (when (and (= event-status "created") (d-rights/is-superuser?))
               [mui/button {:variant   "outlined" :color "secondary"
                            :title     "Nur Superuser, versendet kein Mail/SMS"
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "collecting" :crowdtaskerEvent-published true} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px" :color "orange"}}
                "Direkt Freischalten (superuser)"])

             ]
            [:span {:style {:color "red"}}
             (str
               (when (< (count (str (:crowdtaskerEvent-timeFrom @!event))) 5) "Beginn Datum fehlt, ")
               (when (< (count (str (:crowdtaskerEvent-name @!event))) 1) "Name fehlt, ")
               (when (< (count (str (:crowdtaskerEvent-description @!event))) 1) "Beschreibung fehlt "))]
            [:br]
            [:br]
            [mui/card-content {}
             (log/debug "Open Tab " @!tab)
             [mui/tabs {:value          (or @!tab 0)
                        :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                        :indicatorColor "primary"
                        :textColor      "primary"
                        :variant        "scrollable"
                        }
              [mui/tab {:value 0 :label "Details"}]

              [mui/tab {:value 1 :label "Region"}]

              [mui/tab {:value 2 :label "Aufgaben"}]

              (when (> event-step 2) [mui/tab {:value 3 :label "Auswertung"}])

              ; creating / isWaiting

              ;collecting  2
              ;; (when (and (> event-step 1) (not (empty? (:crowdtaskerEvent-member @!event)))) [mui/tab {:value 4 :label (str "Eingeladen (" (count (:crowdtaskerEvent-member @!event)) ")")}])
              ;collecting  2
              (when (> event-step 1) [mui/tab {:value 5 :label (str "Rückmeldungen (" (count (:crowdtaskerEvent-response @!event)) ")")}])

              (when (> event-step 1) [mui/tab {:value 8 :label (str "Auswertung")}])

              (when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user))}])
              ]
             ;;show-absent? show-standby? show-participated?
             (case (or @!tab 0)
               0 [event-detail-form/get-it !event (not= event-status "created")]

               1 [mui/card-content {}
                  [(event-region/region-selector (not= event-status "created"))]]

               2 [mui/card-content {}
                  [(task-list/get-it !event)]]

               4 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event))]
                  ]
               5 [mui/card-content {}
                  [(event-response-table/get-it (:crowdtaskerEvent-response @!event))]]



               8 [mui/card-content {}
                  [(task-result-list/get-it !event)]]

               99 [mui/card-content {}
                   [:p "Übersicht über Events....."]
                   [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!event)) "," ",\n")]]

               )
             ]]
           ])))))


















